
import axios from 'axios';
//import config from '../../config';
import {envConfig as config} from '../../environment';



export const postUploadUserProfileImage = async(formData,userId)=>{
    //console.log("user profile image upload çalıştı");
            try{
            const url = `${config.apiUrl}/v1/upload/userProfileImage/${userId}`;
            return await axios.post(url,formData,{
                        headers:{
                            'Content-Type':'multipart/form-data'
                        }
                }).then(response => response.data)

            } catch (err) {
                if(err.response.status ===500){
                    console.log("Sunucu problemi var")
                }
                else{
                    console.log(err.response.data.msg);
                }
            }
}

export const postUploadTaleAttachment = async(formData,userId)=>{
  //  console.log("file upload  çalıştı");
            try{
            const url = `${config.apiUrl}/v1/upload/taleAttachment/${userId}`;
            return await axios.post(url,formData,{
                        headers:{
                            'Content-Type':'multipart/form-data'
                        }
                }).then(response => response.data)

            } catch (err) {
                if(err.response.status ===500){
                    console.log("Sunucu problemi var")
                }
                else{
                    console.log(err.response.data.msg);
                }
            }
}


export const getFileUploadByTaleIdApi = (taleId)=>{
    const url = `${config.apiUrl}/v1/utils/fileUploadByTaleId/${taleId}`;
    return axios.get(url)
    .then(response => response.data);
 }

 export const getFileUploadByTaleAttachmentIdApi = (taleAttachmentId)=>{
    const url = `${config.apiUrl}/v1/utils/fileUploadByTaleAttachmentId/${taleAttachmentId}`;
    return axios.get(url)
    .then(response => response.data);
 }


 export const deleteFileUploadByIdApi = (fileObj)=>{
    const url = `${config.apiUrl}/v1/upload/deleteTaleAttachment`;
    return axios.post(url,fileObj)
    .then(response => response.data);
 } 

 export const downlaodFileApi = (url,fileName)=>{
    return axios({
         url: url, //your url
         method: 'GET',
         responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
         const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
       });

    //   return axios.get(url,{
    //     method: 'GET',
    //     responseType: 'blob' 
    //  })
    //  .then(response => {
    //     const file = new Blob(
    //        [response.data]);
    //        return file;
    //  });
 }

 export const appFileUpload = async(formData,userId)=>{
    try{
    const url = `${config.apiUrl}/v1/upload/app/addFile`;
    return await axios.post(url,formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
        }).then(response => response.data)

    } catch (err) {
        if(err.response.status ===500){
            console.log("Sunucu problemi var")
        }
        else{
            console.log(err.response.data.msg);
        }
    }
  }